import { z } from 'zod';

export const Role = z.enum([
    //
    'admin',
    'adminActive',
    'backOffice',
    'finance',
]);
export type Role = z.infer<typeof Role>;
